import { render, staticRenderFns } from "./ViewPatientForm.vue?vue&type=template&id=e78e9752&"
import script from "./ViewPatientForm.vue?vue&type=script&lang=js&"
export * from "./ViewPatientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports